import React from 'react';
import {
  getRehydratableName,
  Link,
  Typography,
  Sizes,
  Rank,
  Heading,
  getClassNameFactory,
} from '@dcl/ui';
import { types, boldTypes } from '@dcl/ui/dist/elements/Heading';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import SupportTicketIcon from './SupportTicketIcon';
import { ISupportTicketProps } from './types';
import './index.css';

export const SupportTicket: React.FC<ISupportTicketProps> = (props) => {
  const { title, description, link, linkText, isBorderVisible = false } = props;
  const getClassName = getClassNameFactory(SupportTicket.displayName);
  return (
    <div
      data-rehydratable={getRehydratableName(SupportTicket.displayName)}
      {...propsToDataAttributes(props)}
      className={getClassName()}
    >
      <div
        className={getClassName({
          descendantName: 'container',
          modifiers: isBorderVisible && 'border',
        })}
      >
        <div
          className={getClassName({
            descendantName: 'textContainer',
            modifiers: isBorderVisible && 'visible',
          })}
        >
          <Heading
            type={types.XtraSmall}
            boldType={boldTypes.black}
            rank={Rank.Second}
            className={getClassName({ descendantName: 'heading' })}
            data-testid="SupportTicket-heading"
          >
            {title}
          </Heading>
          <Typography
            type={Sizes.XXTRASMALL}
            tag={TypographyTags.P}
            className={getClassName({ descendantName: 'description' })}
            data-testid="SupportTicket-description"
          >
            {description}
          </Typography>
        </div>
        <Link iconLeft={SupportTicketIcon} href={link} newWindow>
          <span className={getClassName({ descendantName: 'linkText' })}>
            {linkText}
          </span>
        </Link>
      </div>
    </div>
  );
};

SupportTicket.displayName = 'SupportTicket';
